import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" {...props}><path d="M23.75 25H6.25a3.75 3.75 0 01-3.75-3.75V8.75A3.75 3.75 0 016.25 5h17.5a3.75 3.75 0 013.75 3.75v12.5A3.75 3.75 0 0123.75 25" opacity=".35" /><path d="M12.5 16.25h-5a1.25 1.25 0 000 2.5h5a1.25 1.25 0 000-2.5m15-6.25h-25v3.75h25z" /></svg>;